export const getInitialProps = async ({
  routeInfo,
  context: {
    domain,
    i18n: {culture}
  }
}) => {
  const {
    location: {pathname: path}
  } = routeInfo

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const [seoDataError, {head: helmet} = {}] = await domain.get('get_seo_data_use_case').execute({culture, pageName})

  return {helmet, pageName, seoDataError}
}
